import { randomString } from "../js/tool";

// 生成区块
export const createBaseBlock = function (rows, cols) {
  const list = [];
  for (let i = 0; i < rows; i++) {
    for (let j = 0; j < cols; j++) {
      const block = {
        key: randomString(),
        row: i + 1,
        cols: j + 1,
      };
      if (list[i]) {
        list[i].push(block);
      } else {
        list[i] = [block];
      }
    }
  }
  return list;
};
